import { makeStyles } from "@material-ui/core";
import * as React from "react";
import { displayDate } from "src/helpers";

const useStyles = makeStyles({
  normal: {
    color: "inherit" as "inherit"
  },
  success: {
    color: "#4CAF50"
  },
  warning: {
    color: "#F44336"
  }
});

interface IOwnProps {
  type: "normal" | "warning" | "success";
  date: Date;
}

const DateStatus = ({ type = "normal", date }: IOwnProps) => {
  const classes = useStyles();

  return (
    <span data-qa-selector="date" className={classes[type]}>
      {displayDate(date)}
    </span>
  );
};

export default React.memo(DateStatus);
